import { getHeaders, fetcher } from './ApiClient';

const getAllowedPlatform = (): Promise<any> => {
    const url = `account/subscription/platforms`;
    return fetcher<any>(url, 'GET', getHeaders());
};

export { getAllowedPlatform };
